import { ClickEvent } from "@mcleod/components";
import { AutogenLayoutDatafusionBillingPending } from "./autogen/AutogenLayoutDatafusionBillingPending";
import { Navigation, UrlUtil } from "@mcleod/core";

export class DatafusionBillingPending extends AutogenLayoutDatafusionBillingPending {
    labelOnClick(event: ClickEvent) {
        const count = this.mainDataSource?.activeRow?.get("total") ?? 0;
        const urlParams: string[] = [];
        urlParams.push("inboundPendingSearch=true");
        if (count > 0) {
            Navigation.navigateTo("lme/datafusion/InvoiceHistoryList" + UrlUtil.buildQueryString(urlParams), { newTab: false });
        }
    }
}